<template>
  <div>
    <section class="picture-and-video-edit ly-edit">
      <div class="section-inner">
        <div class="section-cont">
          <h2>사진 및 졸업동영상 관리</h2>
          <p class="site-path">
            <span>Home</span>&nbsp;&gt;&nbsp;
            <span>EDUCATION</span>&nbsp;&gt;&nbsp;
            <span>사진 및 졸업동영상 관리</span>
          </p>
          <!-- /.site-path -->
          <table>  
            <colgroup>
              <col class="col1" />
              <col class="col2" />
            </colgroup>
            <tr>
              <th scope="row"><label for="title">제목</label></th>
              <td>
                <input type="text" name="title" id="title" v-model="title" />
              </td>
            </tr>
            <tr>
              <th scope="row"><label for="admin-id">유튜브 영상</label></th>
              <td class="youtube">
                <input
                  type="text"
                  name="youtube"
                  id="youtube"
                  v-model="youtube_link"
                />
                <span
                  >예)youtube.com/watch?<em>v=MDHjXD5RKH</em>을 입력
                  바랍니다.</span
                >
              </td>
            </tr>
          </table>
          <!-- /.table-->
          <router-link
            :to="{ name: 'PictureAndVideoList' }"
            class="btn-white"
            tag="a"
            >목록</router-link
          >
          <button class="btn-blue btn-right" @click="onSubmitModify">
            수정
          </button>
          <!-- /.btn -->
        </div>
        <app-footer />
      </div>
    </section>
  </div>
</template>

<script>
import AppFooter from "../../AppFooter.vue";

export default {
  props: ["id", "item"],
  components: { AppFooter },
  name: "PictureAndVideoEdit",
  data() {
    return {
      title: this.item != null ? this.item.title : "",
      youtube_link: this.item != null ? this.item.youtube_link : "",
    };
  },
  created() {
    // props are exposed on `this`
    console.log("props id => ", this.id);
    console.log("props pictureandvideo => ", this.item );
  },
  methods: {
    onSubmitModify() {
      console.log("onSubmitModify. -----");

      const payload = {
        id: this.item.id ,
        title: this.title ,
        youtube_link: this.youtube_link
      };

      this.$store.dispatch("education/req_update_pictureandvideo",  payload  )
      .then(( ) => {
        this.$alert("수정하였습니다.").then( () => {
            this.$router.push({ name: "PictureAndVideoList" });
        });
      })
      .catch((error) => {
        console.log("error => ", error);
      });

    },

  },
};
</script>

<style lang="scss" scoped>
input[id="youtube"] {
  width: 230px !important;
  display: inline-block !important;
  margin-right: 20px !important;
}
span {
  font-size: 16px;
  em {
    color: #ff4141;
  }
}
</style>
